import axios from 'axios';
import utils from './utils';
export default {
    send: function send(options) {
        axios.post(options.url, options.data).then(function (response) {
            var data = response.data;
            if (!data || data.code !== 0) {
                options.error && options.error(data && data.msg);
                return;
            }
            options.success && options.success(data);
        })['catch'](function (e) {
            console.error(e);
            options.error && options.error(e);
        });
    },
    read: function read(options) {
        axios.get(options.url).then(function (response) {
            var data = response.data;
            if (!data) {
                options.error && options.error(data && data.msg);
                return;
            }
            console.log('____', data);
            switch (options.type) {
            case 'dplayer-danmaku':
                options.success && options.success(data.data.list.map(function (item) {
                    var _item$, _item$2, _options$origin;
                    return {
                        time: item[0],
                        type: utils.number2Type(item[1]),
                        mode: [
                            1,
                            5,
                            4,
                            6
                        ][item[1]],
                        color: item[2],
                        author: item[3],
                        text: item[4],
                        size: (_item$ = item[5]) !== null && _item$ !== void 0 ? _item$ : 25,
                        date: (_item$2 = item[6]) !== null && _item$2 !== void 0 ? _item$2 : 0,
                        origin: (_options$origin = options.origin) !== null && _options$origin !== void 0 ? _options$origin : 'unknown'
                    };
                }));
                break;
            case 'mfuns-advDanmaku-oldApi':
                options.success && options.success(data.data.map(function (item) {
                    var a = JSON.parse(item);
                    return {
                        time: a[0].start / 1000 || 0,
                        type: 'json',
                        mode: 9,
                        author: '0',
                        text: item,
                        date: 0
                    };
                }));
                break;
            case 'bili-danmaku':
                var bilibiliXMLParser = function bilibiliXMLParser(xmlData) {
                    var dan = [];
                    var xmlDoc = new DOMParser().parseFromString(xmlData, 'text/xml');
                    var nodeList = xmlDoc.childNodes;
                    var generate = function generate(nodeList) {
                        for (var i = 0; i < nodeList.length; i++) {
                            var _cur_node$attributes;
                            var cur_node = nodeList[i];
                            if (cur_node !== null && cur_node !== void 0 && (_cur_node$attributes = cur_node.attributes) !== null && _cur_node$attributes !== void 0 && _cur_node$attributes.length && i > 0) {
                                var _data = cur_node.attributes[0].nodeValue.split(',');
                                _data.push(cur_node.innerHTML);
                                dan.push(_data);
                            } else if (cur_node.childNodes.length > 0) {
                                generate(cur_node.childNodes);
                            }
                        }
                    };
                    generate(nodeList);
                    return dan.map(function (el) {
                        var _el$, _el$2;
                        return {
                            time: +el[0],
                            type: utils.number2Type(+el[1], true),
                            mode: +el[1],
                            color: +el[3],
                            author: el[6],
                            text: el[8],
                            size: (_el$ = +el[2]) !== null && _el$ !== void 0 ? _el$ : 25,
                            date: (_el$2 = +el[4]) !== null && _el$2 !== void 0 ? _el$2 : 0,
                            origin: 'bili'
                        };
                    });
                };
                options.success && options.success(bilibiliXMLParser(data));
                break;
            case 'acfun-danmaku':
                break;
            default:
                options.success && options.success(data);
            }
        })['catch'](function (e) {
            console.error(e);
            options.error && options.error(e);
        });
    }
};